<h3>Added by: {{ (contact.user | resolveUser).email }}</h3>

<rsValidForm #form="rsValidForm" [rsValidOnceInteracted]="true">
  <div class="inputs">
    <div class="input d-inline-block">
      <mat-form-field appearance="fill" floatLabel="always">
        <mat-label>Type</mat-label>
        <mat-select [(ngModel)]="contact.type" rsValid="required">
          <mat-option *ngFor="let type of contactTypes" [value]="type">{{ type | camelConvert }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    &nbsp;&nbsp;
    <div class="input d-inline-block">
      <mat-form-field appearance="fill" floatLabel="always">
        <mat-label>Date</mat-label>
        <input matInput [ngxMatDatetimePicker]="picker" placeholder="Choose a date" [(ngModel)]="contact.date" rsValid="required">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #picker [showSpinners]="true" [showSeconds]="false">
        </ngx-mat-datetime-picker>
      </mat-form-field>
    </div>
    &nbsp;
    <div class="input d-inline-block">
      <mat-form-field [floatLabel]="'always'" appearance="fill">
        <mat-label>Flag for follow-up</mat-label>
        <mat-slide-toggle
          [(ngModel)]="contact.flagged"
          style="user-select: none;"
        >
          <ng-container *ngIf="contact.flagged">Follow-up <mat-icon style="vertical-align: middle;" color="primary">flag</mat-icon></ng-container>
          <ng-container *ngIf="!contact.flagged">Complete <!--<mat-icon style=veritcal-align: middle; color="accent">check</mat-icon>--></ng-container>
        </mat-slide-toggle>
        <textarea matInput hidden style="display: none !important;"></textarea>
      </mat-form-field>
    </div>
  </div>
  <div class="inputs">
    <div class="input full">
      <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">
        <mat-label>Notes</mat-label>
        <input matInput [(ngModel)]="contact.notes" placeholder="Notes" />
      </mat-form-field>
    </div>
  </div>
</rsValidForm>

<mat-divider></mat-divider>
<br/>
<h2>Extension Activities</h2>

<mat-list class="odd-even-list mb-2" *ngIf="activitiesByCategories().length">
  <mat-list-item *ngFor="let activity of activitiesByCategories()">
    <ng-container *ngTemplateOutlet="extensionActivity; context: activity"></ng-container>
  </mat-list-item>

  <!-- Pass in variables -->
  <ng-template #extensionActivity let-key="key" let-type="type">
    <div class="d-flex justify-content-between">
      <div class="align-content-center">
        <app-category-tag [category]="type.category"></app-category-tag>
      </div>
      <div class="align-content-center">
        {{type?.name}}
      </div>
      <div class="align-content-center">
        <button mat-icon-button color="primary" (click)="addToActivity(key, -1)">
          <mat-icon>remove_circle</mat-icon>
        </button>
        {{ contact.activities[key] }}
        <button mat-icon-button color="primary" (click)="addToActivity(key, 1)">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>
    </div>
  </ng-template>
</mat-list>

<div>
  <mat-form-field appearance="fill" floatLabel="always" style="width: 520px; display: inline-block;">
    <mat-label>Add activity: </mat-label>

    <mat-select [(ngModel)]="selectActivity">
      <mat-select-trigger>
        <ng-container *ngIf="selectActivity">
          <mat-icon>{{ selectActivity.categoryIcon }}</mat-icon> {{ selectActivity.categoryName }} - {{selectActivity.name}}
        </ng-container>
      </mat-select-trigger>
      <mat-option>
        <ngx-mat-select-search placeholderLabel="Search" noEntriesFoundLabel="Nothing found.." [ngModel]="activitySearch" (ngModelChange)="activitySearch = $event; filterActivities()"></ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let activity of filteredActivities | async" [value]="activity">
        <mat-icon>{{ activity.categoryIcon }}</mat-icon> {{ activity.categoryName }} - {{activity.name}}
      </mat-option>
    </mat-select>
    <button matSuffix mat-icon-button color="accent" (click)="$event.stopPropagation(); $event.preventDefault(); addActivity(selectActivity)">
      <mat-icon>add</mat-icon>
    </button>
  </mat-form-field>
</div>

<br/>
<mat-divider></mat-divider>
<br/>
<h2>Practice Change & Soil Management Index</h2>

<mat-list class="odd-even-list mb-2">
  <mat-list-item *ngFor="let type of practiceChangeService.types | keyvalue">
    <div class="clickable d-flex w-100">
      <div class="flex-grow-1" (click)="addUpdatePracticeChange(type.key);">
        <app-category-tag (itemClick)="addUpdatePracticeChange(type.key);" [clickable]="true" class="d-inline-block" style="margin-top: 4px; vertical-align: middle;" [category]="type.key"></app-category-tag>
        &nbsp;&nbsp;
        <span style="margin-top: 4px; vertical-align: middle;" class="d-inline-block">
          {{ type.value.name }}
          &nbsp;&nbsp;
          <mat-icon *ngIf="contact[type.value.fieldId] && contact[type.value.fieldId].completed" color="primary">check</mat-icon>
        </span>
      </div>
      <div>
        <button mat-icon-button color="accent" (click)="addUpdatePracticeChange(type.key);">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="warn" *ngIf="contact[type.value.fieldId] && contact[type.value.fieldId].completed" (click)="removePracticeChange(type.key);">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </mat-list-item>
</mat-list>

<!--<div>
  <mat-form-field appearance="fill" floatLabel="always" style="width: 520px; display: inline-block;">
    <mat-label>Add form: </mat-label>
    <mat-select #selectPracticeChange (selectionChange)="addUpdatePracticeChange($event.value); selectPracticeChange.close(); selectPracticeChange.value = null;">
      <mat-option *ngFor="let activity of practiceChangeService.types | keyvalue" [value]="activity.key">
        <app-category-tag class="d-inline-block" style="margin-top: 10px; vertical-align: middle;" [category]="activity.key" [name]="false"></app-category-tag>
        <span class="d-inline-block" style="line-height: 42px; vertical-align: middle; margin-left: 10px;">{{ (activity.key | resolveCategory).name }} - {{ activity.value.name }}</span>
      </mat-option>
    </mat-select>

  </mat-form-field>
</div>-->




<br/>
<ng-template #actionButtons>

  <button mat-button (click)="cancel()">
    Cancel
  </button>

  <button color="primary" mat-button (click)="saveContact()">
    <mat-icon>save</mat-icon> Save
  </button>

</ng-template>
